<template>
  <div class="w">
    <h3 class="title" style="text-align:center">{{ titleText }}</h3>
    <div class="line line1"></div>
    <div class="newCon flex">
      <div
          class="news"
          v-for="(item, index) in list"
          :key="index"
          @click="$router.push(item.path)"
      >
        <div class="news-img"></div>
        <p>{{ item.title }}</p>
      </div>
    </div>
    <el-pagination
        style="text-align: center;margin-bottom: 90px;"
        layout="prev, pager, next"
        :total="1000"
    >
    </el-pagination>
  </div>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'NewsCom',
  props: {
    request: {
      type: Function,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      titleText: this.title || t('newsCom.defaultTitle'),
      list: [
        {
          title: t('newsCom.news1'),
          path: '/news',
        },
        {
          title: t('newsCom.news2'),
          path: '/news',
        },
        {
          title: t('newsCom.news3'),
          path: '/news',
        },
        {
          title: t('newsCom.news4'),
          path: '/news',
        },
        {
          title: t('newsCom.news5'),
          path: '/news',
        },
        {
          title: t('newsCom.news6'),
          path: '/news',
        },
      ],
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateList()
      if (!this.title) {
        this.titleText = t('newsCom.defaultTitle')
      }
    },
    title(val) {
      this.titleText = val
    }
  },
  mounted() {
    this.updateList()
  },
  methods: {
    updateList() {
      this.list = [
        {
          title: t('newsCom.news1'),
          path: '/news',
        },
        {
          title: t('newsCom.news2'),
          path: '/news',
        },
        {
          title: t('newsCom.news3'),
          path: '/news',
        },
        {
          title: t('newsCom.news4'),
          path: '/news',
        },
        {
          title: t('newsCom.news5'),
          path: '/news',
        },
        {
          title: t('newsCom.news6'),
          path: '/news',
        },
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.newCon {
  height: 836px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  margin-top: 40px;
  margin-bottom: 72px;
  overflow: hidden;
}
.news {
  width: 440px;
  cursor: pointer;
  &:hover {
    .news-img {
      transform: scale(1.02);
    }
  }
  .news-img {
    width: 440px;
    height: 336px;
    background-color: skyblue;
  }
  p {
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
  }
}
</style>